import clsx from 'clsx';
import React from 'react';

interface DisclosureProps {
  className?: string;
}

const Disclosure = ({ className }: DisclosureProps) => {
  return (
    <div className={clsx('mb-32 font-suisse-screen text-disclosure-sm', className)}>
      Your subscription will renew and be charged today. At the end of the three months free of Pro,
      access will return to our Annual tier for the remainder of the term.
    </div>
  );
};

export default Disclosure;
